import React from 'react';
import { Button, Spin, Checkbox, Form, Icon, Input, message, Dropdown, Menu, Card, Row, Col, Layout, Select, Divider, Drawer } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { auth, database, functions } from '../firebase/firebase';
import ReactPlayer from 'react-player'
import Moment from 'moment';
import localization from 'moment/locale/es'
import AutoPlaySilentVideo from './AutoPlaySilentVideo';
import { userSignOut } from "appRedux/actions/Auth";

import {
	hideMessage,
	showAuthLoader,
	userFacebookSignIn,
	userGithubSignIn,
	userGoogleSignIn,
	userSignIn,
	userTwitterSignIn
} from 'appRedux/actions/Auth';

import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress/index';
import Topbar from './Topbar/index';
import HorizontalDefault from './Topbar/HorizontalDefault/index';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const htmlContent = `
<!DOCTYPE  html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="es" lang="es"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"/><title>3 Información para Prescribir Amplia (IPP) Gelan Plus®</title><meta name="author" content="Estefania Garcia Contreras"/><style type="text/css"> * {margin:0; padding:0; text-indent:0; }
 p { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; margin:0pt; }
 h1 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }
 .h2 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 6.5pt; vertical-align: 2pt; }
 .s1 { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; vertical-align: 2pt; }
 .a, a { color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }
 li {display: block; }
 #l1 {padding-left: 0pt;counter-reset: c1 2; }
 #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:"Arial Narrow", sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }
 #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }
 #l2 {padding-left: 0pt; }
 #l2> li>*:first-child:before {content: "- "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }
 #l3 {padding-left: 0pt; }
 #l3> li>*:first-child:before {content: "- "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }
</style></head><body><p style="padding-top: 4pt;padding-left: 145pt;text-indent: 0pt;text-align: center;">INFORMACIÓN PARA PRESCRIBIR AMPLIA</p><h1 style="padding-left: 144pt;text-indent: 0pt;text-align: center;">GELAN PLUS<span class="h2">®</span></h1><p style="text-indent: 0pt;text-align: left;"><br/></p><ol id="l1"><li data-list-text="2."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">DENOMINACIÓN GENÉRICA:</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Magaldrato, Simeticona.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="3."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">FORMA FARMACÉUTICA Y FORMULACIÓN:</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><h1 style="padding-top: 5pt;padding-left: 76pt;text-indent: 0pt;text-align: left;">Gel</h1><p style="padding-left: 14pt;text-indent: 0pt;text-align: left;">Cada 100 mL de gel contienen: Magaldrato</p><p style="padding-left: 14pt;text-indent: 0pt;text-align: left;">Simeticona Vehículo cbp</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">8.0 g</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">1.0 g</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">100 mL</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="4."><h1 style="padding-top: 5pt;padding-left: 76pt;text-indent: -17pt;text-align: left;">INDICACIONES TERAPÉUTICAS</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><ul id="l2"><li data-list-text="-"><p style="padding-left: 23pt;text-indent: -18pt;text-align: left;">Enfermedad ácido-péptica: esofagitis por reflujo, reflujo gastroesofágico, hernia hiatal, gastritis aguda y crónica, úlcera gástrica, úlcera duodenal.</p></li><li data-list-text="-"><p style="padding-left: 23pt;text-indent: -17pt;line-height: 11pt;text-align: left;">Gastritis alcalina, etílica y medicamentosa, dispepsia no ulcerosa, úlceras por estrés.</p></li><li data-list-text="-"><p style="padding-left: 23pt;text-indent: -17pt;line-height: 11pt;text-align: left;">Medicamento concomitante en el tratamiento con inhibidores de la bomba de protones o bloqueadores H2.</p></li><li data-list-text="-"><p style="padding-left: 23pt;text-indent: -17pt;text-align: left;">Terapia de mantenimiento para los padecimientos ácido-pépticos.</p></li></ul><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="5."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">FARMACOCINETICA Y FARMACODINAMIA</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">GELAN PLUS<span class="s1">® </span>es un antiácido/antiflatulento con efecto amortiguador de pH y de captación de sales biliares.</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">La formulación de magaldrato/simeticona o sus fármacos en forma individual tienen las siguientes propiedades farmacodinámicas:</p><p style="text-indent: 0pt;text-align: left;"><br/></p><ul id="l3"><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: left;">Ajusta el pH gástrico entre 3 y 5, intervalo que ayuda a la curación de las lesiones ácido-pépticas e induce alivio rápido de los síntomas (dolor, ardor, pirosis).</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -17pt;line-height: 11pt;text-align: left;">No contiene agentes alcalinizantes, por lo que no provoca rebote ácido.</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -17pt;text-align: left;">Se adhiere a la mucosa dañada, formando un recubrimiento protector.</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: left;">Permanece en el estómago aproximadamente 35 minutos más que los antiácidos convencionales a base de hidróxidos de aluminio y magnesio.</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: left;">En un pH entre 3 y 5, el magaldrato atrapa 100% de la pepsina, lo que inactiva la proteolisis y favorece la curación de las lesiones de la mucosa.</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: left;">El magaldrato tiene la capacidad de ligar ácidos biliares y lisolecitina similar a la colestiramina, lo cual reduce la agresividad del reflujo duodenogástrico</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: left;">El aluminio contenido en esta formulación se encuentra incorporado a las moléculas de magaldrato, por lo que al paso del tiempo no se oxida y no pierde la capacidad de neutralización.</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -17pt;line-height: 11pt;text-align: left;">La acción del magaldrato se basa en la neutralización del ácido gástrico.</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: left;">La simeticona contenida en GELAN PLUS<span class="s1">® </span>es un agente antiespumante que contribuye a disminuir la distensión gástrica; por lo tanto, disminuye el reflujo gastroesofágico, reduciendo la sintomatología dispéptica.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">La formulación de magaldrato/simeticona o sus fármacos en forma individual tienen las siguientes propiedades farmacocinéticas:</p></li><li data-list-text="-"><p style="padding-left: 76pt;text-indent: -18pt;text-align: justify;">Durante el proceso de neutralización inducido por el magaldrato se liberan pequeñas cantidades de iones magnesio y aluminio, los cuales durante el tránsito intestinal son convertidos en fosfatos poco solubles para ser excretados en heces.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">Tanto el magaldrato como la simeticona prácticamente no se absorben, por lo que carecen de efectos sistémicos clínicamente significativos. La cantidad de aluminio y magnesio que la molécula de magaldrato libera es mínima.</p></li></ul></li><li data-list-text="6."><h1 style="padding-top: 4pt;padding-left: 76pt;text-indent: -17pt;text-align: left;">CONTRAINDICACIONES</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">Hipersensibilidad a los componentes de la fórmula. En pacientes con disfunción renal severa (depuración de creatinina &lt; 30 ml/min), GELAN PLUS<span class="s1">® </span>deberá ser usado sólo con vigilancia de los niveles séricos de magnesio y aluminio. Los niveles séricos de aluminio no deberán exceder los 40 ng/ml.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="7."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">PRECAUCIONES GENERALES</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Debido a que no hay suficiente experiencia con el uso de esta formulación en niños menores de 12 años, no es recomendable el uso de GELAN PLUS<span class="s1">® </span>en este grupo de edad.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">En pacientes con disfunción renal se pueden presentar niveles altos de aluminio en plasma y tejido (predominantemente nervioso y óseo), manifestándose como fenómenos de sobredosificación.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Debido a la posible conexión entre niveles elevados de aluminio sérico y el desarrollo de encefalopatías, se deberá tener cuidado especial en pacientes que requieren diálisis.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">En tratamiento a largo plazo, la concentración de aluminio en sangre deberá monitorearse regularmente y no deberá exceder de 40 ng/ml.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="8."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">RESTRICCIONES DE USO DURANTE EL EMBARAZO Y LA LACTANCIA</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">Todas las formulaciones de magaldrato/simeticona deben utilizarse durante el embarazo y la lactancia solo bajo prescripción médica, por períodos cortos y previa evaluación riesgo/beneficio caso por caso, debido principalmente a los riesgos asociados a la administración de aluminio.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="9."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">REACCIONES SECUNDARIAS Y ADVERSAS</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">Dentro de los eventos/efectos adversos más frecuentes que se han observado con esta formulación están la disminución en la consistencia de las heces y diarrea. Raramente se ha observado depósitos de aluminio y depleción de fosfato, sobre todo, asociados a administración prolongada o a altas dosis.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="10."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">INTERACCIONES MEDICAMENTOSAS Y DE OTRO GENERO</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">Debido a que los antiácidos pueden afectar la absorción de medicamentos pH dependientes, se recomienda que transcurran de 1 a 2 horas entre la ingesta de ambos. En particular, con el uso de antiácidos se ha observado una reducción sustancial en la absorción de tetraciclinas y derivados de la quinolona (ciprofloxacino, ofloxacino y norfloxacino).</p><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">La ingesta simultánea de antiácidos que contienen aluminio o de bebidas ácidas (jugo de frutas, vino, etc.) o tabletas efervescentes (con ácido cítrico o tartárico), incrementa la absorción intestinal de aluminio.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="11."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">ALTERACIONES EN LOS RESULTADOS DE PRUEBAS DE LABORATORIO</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">La administración de la formulación magaldrato/simeticona no se ha asociado a alguna alteración clínicamente significativa en los resultados de pruebas de laboratorio.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="12."><h1 style="padding-left: 76pt;text-indent: -18pt;line-height: 114%;text-align: left;">PRECAUCIONES Y RELACIÓN CON EFECTOS DE CARCINOGÉNESIS, MUTAGÉNESIS Y SOBRE LA FERTILIDAD</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">No se ha determinado la toxicidad aguda de la formulación magaldrato/simeticona debido a una excreción renal relativamente rápida y una baja absorción.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">El potencial mutagénico del magaldrato no ha sido suficientemente investigado. Para compuestos de aluminio no hay evidencia relevante de ningún potencial mutagénico.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">No se han realizado estudios sobre el potencial carcinogénico del magaldrato.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">No hay estudios de embriotoxicidad en animales con esta formulación. Tampoco existe evidencia de riesgo alguno de malformación en humanos, aunque efectos de embriotoxicidad y fototoxicidad se han observado en estudios con otros compuestos de aluminio; por ejemplo, estudios en ratas han mostrado un incremento en la mortalidad posnatal y retraso en el desarrollo neuromotor del feto</p></li><li data-list-text="13."><h1 style="padding-top: 4pt;padding-left: 76pt;text-indent: -17pt;text-align: left;">OSIS Y VIA DE ADMINISTRACION</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">Oral. Tomar según sea necesario, 1-2 cucharadas de 10 ml o 10-20 ml del vaso dosificador. Se recomienda no exceder una dosis diaria de 6 400 mg de magaldrato (8 cucharadas de 10 ml en 24 h de GELAN PLUS<span class="s1">®</span>).</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">En caso de gastritis y úlcera gástrica, GELAN PLUS<span class="s1">® </span>deberá tomarse 1 hora después de los alimentos y antes de dormir. En casos de úlcera duodenal, GELAN PLUS<span class="s1">® </span>deberá tomarse entre 1 y 3 horas después de los alimentos y antes de dormir. En ambos casos, el tratamiento deberá continuarse por lo menos 4 semanas, aun si los síntomas hubieran desaparecido.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">GELAN PLUS<span class="s1">® </span>deberá tomarse entre alimentos y antes de dormir.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="14."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">MANIFESTACIONES Y MANEJO DE LA SOBREDOSIFICACIÓN O INGESTA ACCIDENTAL</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: justify;">En caso de sobredosificación está indicada la administración de tratamiento de soporte. Se ha reportado con el uso de Cuando se ingiere GELAN PLUS<span class="s1">® </span>en cantidades superiores a las recomendadas puede presentarse disminución en la consistencia de las heces; sin embargo, la aparición de diarrea es rara.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="15."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">PRESENTACIONES</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Frasco con 250 mL</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Caja con frasco con 250 mL</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Caja con frasco con 250 mL y vaso dosificador. Caja con 4 frascos con 40 mL</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Caja con 8 frascos con 40 mL Frasco con 40 mL con y sin caja Caja con 2 frascos con 40 mL</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="16."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">RECOMENDACIONES SOBRE ALMACENAMIENTO</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Consérvese a no más de 30°C.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="17."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">LEYENDAS DE PROTECCIÓN</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">No se deje al alcance de los niños.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Si persisten las molestias, consulte a su médico. Literatura exclusiva para médicos.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Agítese antes de usarse.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">No contiene sacarosa. Contiene 20.04% de otros azúcares.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">10 mL de GELAN PLUS<span class="s1">® </span>aportan 9.8 kcal, por lo que es apto para pacientes con diabetes bajo control médico. Consérvese el frasco bien cerrado.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;"><a href="mailto:farmacovigilancia@cofepris.gob.mx" class="a" target="_blank">Reporte  las  sospechas  de  reacciones  adversas  al  correo  </a><a href="mailto:farmacovigilancia@chinoin.com" class="a" target="_blank">farmacovigilancia@cofepris.gob.mx  y </a><a href="mailto:farmacovigilancia@chinoin.com" target="_blank">farmacovigilancia@chinoin.com</a></p><p style="padding-left: 9pt;text-indent: 0pt;line-height: 11pt;text-align: left;">Para información relacionada con el producto, comuníquese al teléfono 01 800 841 9192</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="18."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">NOMBRE Y DOMICILIO DEL LABORATORIO PRODUCTOR</h1><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">PRODUCTOS FARMACÉUTICOS, S.A. DE C.V.</p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">Km 4.2 Carretera a Pabellón de Hidalgo Rincón de Romos C.P. 20420, Aguascalientes.</p><p style="text-indent: 0pt;text-align: left;"><br/></p></li><li data-list-text="19."><h1 style="padding-left: 76pt;text-indent: -17pt;text-align: left;">Reg. No.</h1></li></ol><p style="text-indent: 0pt;text-align: left;"><br/></p><p style="padding-left: 9pt;text-indent: 0pt;text-align: left;">454M2015 SSA VI</p></body></html>


`;

class Linea3 extends React.Component {

	constructor() {
		super();
		this.state = {
			loading: false,
			subject: "Dudas sobre productos Chinoin®",
			message: '',
			showVideo: false,
			videoId: '',
			showVisit: false,
			selectedVisit: '',
			visitStatus: "",
			videoTitle: '',
			videoCategory: '',
			email: '',
			contactEmail: '',
			contactSubject: 'Dudas sobre productos Chinoin®',
			contactMessage: '',
			handleVisitLoader:false,

		};
		this.handleSubmit = this.handleSubmit.bind(this);
		//this.setRedirect = this.setRedirect.bind(this);
		//this.handleSignIn = this.handleSignIn.bind(this);
		this.handleSubject = this.handleSubject.bind(this);
		this.handleVisits = this.handleVisits.bind(this);

		this.handleEmail = this.handleEmail.bind(this);
		this.handleMessage = this.handleMessage.bind(this);

	}

	
	getInfo(user) {
		//console.log("ALL USER INFO CALLED");
		var _this = this;

		database
			.collection("users")
			.where("email", "==", user.email)
			.get()
			.then(function (querySnapshot) {

				querySnapshot.forEach(function (doc) {
					_this.setState({ user: doc.data(), userId: doc.id });
					console.log("ID: " + doc.id);
				});
			})
			.catch(function (error) {
				//console.log("Error getVideosInformation :", error);
			});
	}
	ref = player => {
		this.player = player
	}

	componentDidMount() {
		var _this = this;

		auth.onAuthStateChanged(user => {
			if (user) {
				_this.getInfo(user);
			}
		});
	}

	handleVisits() {
		console.log("handleVisits")
		this.setState({handleVisitLoader:true})

		var addMessage = functions.httpsCallable('medicalvisit');
		Moment().locale('es', localization)

		var dateMessage = Moment(new Date())
			.locale('es')
			.format('D [de] MMMM [del]  YYYY');
		var _this = this;
		addMessage({
			userId: this.state.userId,

			date: dateMessage,
			method: this.state.selectedVisit
		})
			.then(function (result) {
				console.log("sucess")
				_this.setState({handleVisitLoader:false})

				// Read result of the Cloud Function.
				_this.setState({ visitStatus: "success" })
				//var sanitizedMessage = result.data.text;
			})
			.catch(function (error) {

				_this.setState({ visitStatus: "error" })
				_this.setState({handleVisitLoader:false})

				// Getting the Error details.
				var code = error.code;
				var message = error.message;
				var details = error.details;

				console.log("Function error")
				console.log(code)
				console.log(message)
				//console.log(details)
				// ...
			});
	}
	handleSubmit = (e) => {
		e.preventDefault();
	
		if(this.state.contactEmail != "" && this.state.contactSubject != "" && this.state.contactMessage != ""){
			if(/\S+@\S+\.\S+/.test(this.state.contactEmail)){
			//	if(this.state.contactEmail.includes("@") &&this.state.contactEmail.includes(".")){

			var addMessage = functions.httpsCallable('contactform');

		var dateMessage = Moment(new Date())
			.locale('es')
			.format('D [de] MMMM [del]  YYYY');
		var _this = this;
		addMessage({
			email: this.state.contactEmail,
			subject: this.state.contactSubject,
			date: dateMessage,
			message: this.state.contactMessage
		})
			.then(function (result) {
				console.log("sucess")
				alert("Enviado!")
				_this.setState({ contactEmail: '', contactSubject: '', contactMessage: '' })
				// Read result of the Cloud Function.
				_this.setState({ visitStatus: "success" })
				//var sanitizedMessage = result.data.text;
			})
			.catch(function (error) {

				_this.setState({ visitStatus: "error" })

				// Getting the Error details.
				var code = error.code;
				var message = error.message;
				var details = error.details;

				console.log("Function error")
				console.log(code)
				console.log(message)
				//console.log(details)
				// ...
			});
		}else{
			alert("Correo electrónico inválido")
		}
		}else{
			alert("Por favor llene todos los campos")
		}

	};

	handleSubject(e) {
		console.log(e);
		this.setState({ contactSubject: e});
	}
	handleMessage(e) {
		console.log(e.target.value);
		this.setState({ contactMessage: e.target.value });
	}
	handleEmail(e) {
		console.log(e.target.value);
		this.setState({ contactEmail: e.target.value });
	}
	componentDidUpdate() { }

	render() {

		const handleVideoClick = (videoid, videoTitle, videoCategory) => {
	
			console.log('The link was clicked.');
			this.setState({ showVideo: true, videoId: videoid, videoTitle: videoTitle, videoCategory: videoCategory });
		}

		return (
			<div className="scrollable">


				<HorizontalDefault />
				
				<div class="menu-mobile">

<div>
	<Row span={24}>

		<Col span={1}></Col>
		<Col span={3}>
			<div onClick={() => this.setState({ visible: true })}><Icon type="menu" style={{ fontSize: '36px', color: '#fff' }} /> </div>
		</Col>
		<Col span={4}><a href="/"><img id="home-icon" src={require('../assets/images/home_icon.png')} alt="innovacion_chinoin" title="innovacion_chinoin" /></a></Col>
		<Col span={7}>
			<img src={require('../assets/images/logo-main-small.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />
		</Col>
		<Col span={2}></Col>
		<Col span={6}>
			<img id="slight-top" src={require('../assets/images/norutec.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />
		</Col>
		<Col span={1}></Col>

	</Row>

	<Drawer


		placement="right"
		closable={false}
		visible={this.state.visible}
	>
		<br></br>
		<Icon type="close" style={{ fontSize: '30px', color: '#fff', float: 'right' }} onClick={() => this.setState({ visible: false })} />
		<a href="/"><p class="drawer-item">ACERCA DE</p></a>
		<Divider />
		<a href="/profesional-salud"><p class="drawer-item">PROFESIONAL DE LA SALUD</p></a>
		<ul>
			<li><a href="/educacion-medica"><p class="drawer-subitem">EDUCACIÓN MÉDICA CONTINUA</p></a><Divider></Divider></li>

			<li><a href="/informacion-producto"><p class="drawer-subitem">INFORMACIÓN DE PRODUCTO</p></a><Divider></Divider></li>

			<li><a href="/experiencia-clinica"><p class="drawer-subitem">EXPERIENCIA CLÍNICA</p></a><Divider></Divider></li>
		</ul>
		<a href="/gastrobalance"><p class="drawer-item">GASTROBALANCE</p></a>
		<Divider />
		<a href="/#contacto"><p class="drawer-item">CONTACTO</p></a>
		<Divider />
		{(this.state.user != {} && this.state.user != null) ? <a onClick={() => this.props.userSignOut()}><p class="drawer-item">CERRAR SESIÓN</p></a> : null}
	</Drawer>
</div>


</div>

				<div className="">
				<div class="mobile-spacer">
						<br></br>	<br></br>	<br></br>	<br></br>	<br></br>
					</div>

					<Row>
					<Col lg={6} md={6} sm={0} xs={0}></Col>
					<Col lg={12} md={12} sm={22} xs={22}><div class="no-style" dangerouslySetInnerHTML={{ __html: htmlContent }} /></Col>
						<Col lg={6} md={6} sm={0} xs={0}></Col>
					</Row>
					<br></br><br></br>
					<div class="desktop-spacer">
					<br></br><br></br><br></br><br></br><br></br><br></br><br></br>
										</div>
								

					<Row id="footer-solid">
						<Col span={2}>

						</Col>
						<Col lg={4} md={4} sm={20} xs={20}>
							<ul className="list-no-bullet">

								<li>
									<br></br>
									<Row>
										<Col lg={0} md={0} sm={2} xs={2}></Col>

										
										<Col lg={18} md={18} sm={18} xs={18}>
										<span class="footer-small-text">Plataforma académica patrocinada por Productos Farmacéuticos Chinoin®<br></br><br></br><br></br></span>

											<span class="footer-small-text">Productos Farmacéuticos Chinoin®<br></br>

												Lago Tangañica #18<br></br>
												Colonia Granada, 11520<br></br>
												México, D.F.<br></br>
												(55) 5262 31 00<br></br>
												Fax: (55) 5531 43 49<br></br>
												ventas@chinoin.com</span>
										</Col>
									</Row>
								</li>
							</ul>
						</Col>
						<Col lg={4} md={4} sm={4} xs={4}></Col>

						<Col lg={4} md={4} sm={19} xs={19}>
							<ul id="social-ul" className='margin-left' >
								<li><img class="footer-logo-norutec" src={require('../assets/images/norutec_alone.png')} /></li>
								<br></br>	
								<li><img class="footer-logo-norutec" src={require('../assets/images/benequer.png')} /></li>

								<br></br>	
								<li><img class="footer-logo-brand" src={require('../assets/images/talnesis.png')} /></li>
								<br></br>	
								<li><img class="footer-logo-brand-gelan" src={require('../assets/images/gelan-small.webp')} /></li>
								<br></br>
								<li><img class="footer-logo-brand-gelan" src={require('../assets/images/anara.png')} /></li>
								<br></br>	<br></br>	
								<li><img class="footer-logo-brand-inter" src={require('../assets/images/logo-intersistemas.png')} />
									<br></br>
									<span id="dev-text"> Desarrollado por Intersistemas S.A de C.V</span>
								</li>
								<br></br>		<br></br>			<br></br>
							</ul>
						</Col>
						<Col lg={4} md={4} sm={4} xs={4}>

						</Col>
						<Col lg={4} md={4} sm={20} xs={20}>
							<span class="regular-text">Accesos rápidos</span>
							<ul className="list-no-bullet">
								<li><a href="/#acerca"> <span className='footer-links'>Acerca de</span></a></li>
								<li><a href="profesional-salud"> <span className='footer-links'>Acceso Profesional de la Salud</span></a></li>
								<li><a href="gastrobalance"> <span className='footer-links'>Gastrobalance</span></a></li>
								<li><a href="puntosdeventa"> <span className='footer-links'>Puntos de venta</span></a></li>
								<li><a href="https://www.chinoin.com/"> <span className='footer-links'>Sobre Chinoin</span></a></li>
							<li><a href="https://www.chinoingastroinnovacion.com/aviso" target="_blank"> <span className='footer-links'>Aviso de privacidad</span></a></li>
								<div className='mobile-spacer'>
								<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
							</div>
								

							</ul>
						</Col>

					</Row>
					<a href="https://www.chinoin.com/" target="_blank"><img id="corner-logo" src={require('../assets/images/esquina.png')} alt="innovacion_chinoin" title="innovacion_chinoin" /></a>

					<div id="social">
						<ul id="social-ul">
								<li className='social-list'><a href="https://www.facebook.com/ChinoinProductosFarmaceuticos" target="_blank"><img class='social-icon' src={require('../assets/images/face.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.instagram.com/chinoinpf/" target="_blank"><img class='social-icon' src={require('../assets/images/insta.webp')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.linkedin.com/company/chinoinpf/" target="_blank"><img class='social-icon' src={require('../assets/images/in.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.tiktok.com/@chinoinpf?is_from_webapp=1&sender_device=pc" target="_blank"><img class='social-icon' src={require('../assets/images/tiktok.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://twitter.com/ChinoinPF" target="_blank"><img class='social-icon' src={require('../assets/images/twitter.png')} alt="" title="" /></a></li>
							<li className='social-list'><a href="https://www.youtube.com/channel/UC3SguU-Dc1L61rFbBm8Lbww" target="_blank"><img class='social-icon' src={require('../assets/images/youtube.png')} alt="" title="" /></a></li>


						</ul>

					</div>

				</div>
				<div class="visit-ribbon" >
					<Row onClick={() => this.setState({ showVisit: true })}>
						<Col span={4}><img class="event-icon-ribbon" src={require('../assets/images/solicite.png')} alt="innovacion_chinoin" title="innovacion_chinoin" /></Col>
					
						<Col span={20}><br></br><div class="ribbon"><span>Solicite Visita Médica</span></div></Col>
					</Row>
				</div>
				{this.state.showVideo ? <div class="videoView">
					<div className="videoChild">
					<img class="close" onClick={() => this.setState({showVideo:false})} src={require('../assets/images/close.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />

						<div className='rcorners2' >
						<img class="event-icon-small-fixed" src={require('../assets/images/shield.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />
						<br></br>
						<span class="home-text-small">{this.state.videoCategory}</span><br></br>
						<span class="text-h3">{this.state.videoTitle}</span><br></br><br></br>
							<ReactPlayer
							width={window.innerWidth > 1000 ? "800px" : "100%"}
							ref={this.ref}
							playing="playing"

							height={window.innerWidth > 1000 ? "430px" : "330px"}
								url={"https://player.vimeo.com/video/"+this.state.videoId+"?autoplay=1&loop=1&autopause=0"}
								controls="controls" />
							<br></br>
						
						</div>
					</div>

				</div> : <div></div>}
				{this.state.showVisit ? <div class="videoView">
					<div className="visitDiv">
						<img class="close" onClick={() => this.setState({ showVisit: false })} src={require('../assets/images/close.png')} alt="innovacion_chinoin" title="innovacion_chinoin" />

						<div id="centered">
							<div className='rcorners2' >
								<br></br>
								<Row>
									<Col span={10}></Col>
									<Col span={12}>
										<span class="home-text-small">Gastro-In</span><br></br>
									</Col>
								</Row>
								<Row>
									<Col span={2}></Col>
									<Col span={20}>
										<span class="font-huge">Solicitud de Visita Médica</span><br></br><br></br>
										<span class="visit-text-blue">Nos podremos en contacto con usted en breve</span><br></br>
										<span class="visit-text">¿Cuál de los siguientes medios es el de su preferencia?</span><br></br>
										<Dropdown id="visitselect" overlayStyle={{ backgroundColor: "#000" }} overlay={<Menu>
											<Menu.Item onClick={() => this.setState({ selectedVisit: "Correo electrónico" })}>
												<p className="dark-span" >Correo Electrónico</p>
											</Menu.Item>
											<Menu.Item onClick={() => this.setState({ selectedVisit: "WhatsApp" })}>
												<p className="dark-span" >WhatsApp</p>

											</Menu.Item>
											<Menu.Item onClick={() => this.setState({ selectedVisit: "Correo Electrónico y WhatsApp" })}>
												<p className="dark-span">Correo electrónico y WhatsApp</p>

											</Menu.Item>
										</Menu>} placement="bottomCenter">
											<div class="home-button-gray"><p className='clear-span'>{this.state.selectedVisit == '' ? "Seleccione su opción  " : this.state.selectedVisit}&nbsp;&nbsp;<Icon type="caret-down" style={{ fontSize: '16px', color: '#FFF' }} theme="outlined" /> </p></div>
										</Dropdown>
										<span class="visit-text">De click en ACEPTAR para confirmar su Solicitud de Visita Médica</span><br></br>

										{this.state.handleVisitLoader?<Spin tip="Enviando..."/>:
											<div class="home-button" onClick={this.handleVisits}><span>Aceptar</span></div>}									</Col>
								</Row>
								<Row>
									<Col span={6}></Col>

								</Row>
								<br></br>	<br></br>
								{this.state.visitStatus == "success" ? <span class="visit-text-blue">¡Su solicitud ha sido enviada!</span> : <div></div>}
								{this.state.visitStatus == "error" ? <span class="visit-text-blue">Se produjo un error</span> : <div></div>}

								<br></br>

							</div>
						</div>
					</div>
					

				</div> : <div></div>}
				
			</div>
		);
	}
}
const WrappedNormalForgetForm = Form.create()(Linea3);

export default connect(null, { userSignOut })(Linea3);
